// extracted by mini-css-extract-plugin
module.exports = {"container":"Store_container__1t5B9"};